import { connect } from 'react-redux'
import TeamMemberFile from './TeamMemberFile'
import { getDataSource } from '../../store/appReducer'
import { getFormValues } from 'redux-form'
import { DATASOURCES, FORMS } from '../../constants'
import {
  setInitialTeamMemberData,
  getTeamMemberFileData,
  handleOnEditTeamMemberSubmit,
  handleOnTeamMemberDeleteClick,
  getAppointmentNotificationsSettings,
  handleAppointmentNotificationsChange,
  setAccountActivate,
  setAccountDeactivate,
  handleOnReactivateAccountClick,
  handleOnDeactivateAccountClick,
} from './module'

const mapActionCreators = {
  setInitialTeamMemberData,
  getTeamMemberFileData,
  handleOnEditTeamMemberSubmit,
  handleOnTeamMemberDeleteClick,
  getAppointmentNotificationsSettings,
  handleAppointmentNotificationsChange,
  setAccountActivate,
  setAccountDeactivate,
  handleOnReactivateAccountClick,
  handleOnDeactivateAccountClick,
}

const mapStateToProps = state => ({
  dataIsFetching: state.teamMemberFile.dataIsFetching,
  dataLastUpdated: state.teamMemberFile.dataLastUpdated,
  isAccountDeactivate: state.teamMemberFile.isAccountDeactivate,
  selectedTeamMemberId: state.teamMemberFile.selectedTeamMemberId,
  physicians: getDataSource(state, DATASOURCES.PHYSICIANS),
  editMemberFormData: getFormValues(FORMS.EDIT_MEMBER_FORM)(state),
  me: getDataSource(state, DATASOURCES.ME),
  notification: getDataSource(state, DATASOURCES.MEMBER_NOTIFICATION_SETTINGS),
})

export default connect(
  mapStateToProps,
  mapActionCreators
)(TeamMemberFile)



// WEBPACK FOOTER //
// ./src/legacy/pages/TeamMemberFile/container.js